var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content", attrs: { id: "patrol-form" } },
    [
      _c("Titlebar", { attrs: { incrustation: "fa-history" } }, [
        _c("h1", [_vm._v("Test Planning")]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "container-fluid full-height col-no-padding calendar-container",
        },
        [
          _c("DatePicker", {
            attrs: { position: { v: "top", h: "center" } },
            model: {
              value: _vm.selectedDate,
              callback: function ($$v) {
                _vm.selectedDate = $$v
              },
              expression: "selectedDate",
            },
          }),
          _vm._v(" "),
          _c("Calendar", {
            ref: "calendar",
            attrs: { config: _vm.config },
            on: {
              viewRender: _vm.viewRender,
              eventRender: _vm.eventRender,
              dayClick: _vm.dayClick,
              eventClick: _vm.eventClick,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Toolbar",
        [
          _c("Btn", { staticClass: "default" }, [
            _c("i", { staticClass: "fa fa-clock-o" }),
            _vm._v(
              "   " + _vm._s(_vm.$t("patrol.planning.btns.add")) + "\n        "
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "on-clickaway",
              rawName: "v-on-clickaway",
              value: _vm.closePopup,
              expression: "closePopup",
            },
          ],
          ref: "popup",
          staticClass: "calendar-popup",
          class: { show: _vm.showPopup },
        },
        [
          _c("div", { staticClass: "calendar-popup-arrow" }),
          _vm._v(" "),
          _c("div", { staticClass: "calendar-popup-inner" }, [
            _c("div", { staticClass: "popup-row" }, [
              _c("label", [_vm._v("Ronde")]),
              _c("span", [_vm._v(_vm._s(_vm.eventInfos.title))]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "popup-row" }, [
              _c("label", [_vm._v("Ressource")]),
              _c("span", [
                _vm._v(_vm._s(_vm.eventInfos.properties.resource.name)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "popup-row" }, [
              _c("label", [_vm._v("Date")]),
              _c("span", [
                _vm._v(_vm._s(_vm.getStartDateFormated(_vm.eventInfos.start))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "popup-row" }, [
              _c("label", [_vm._v("Répétition")]),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.getRepeatLabel(_vm.eventInfos.properties.repeat))
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "popup-row" }, [
              _c("label", [_vm._v("État")]),
              _c(
                "span",
                { class: "patrol-state-" + _vm.eventInfos.properties.state },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "patrol.planning.states.state" +
                          _vm.eventInfos.properties.state
                      )
                    )
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "popup-buttons" },
              [
                _c(
                  "Btn",
                  {
                    staticClass: "primary accent",
                    attrs: {
                      title: _vm.$t("patrol.planning.btns.popup.compare"),
                    },
                  },
                  [_c("i", { staticClass: "fa fa-eye" })]
                ),
                _vm._v(" "),
                _c(
                  "Btn",
                  {
                    staticClass: "secondary",
                    attrs: {
                      title: _vm.$t("patrol.planning.btns.popup.editEvent"),
                    },
                  },
                  [_c("i", { staticClass: "fa fa-pencil" })]
                ),
                _vm._v(" "),
                _c(
                  "Btn",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.eventInfos.properties.seriesId != null,
                        expression: "eventInfos.properties.seriesId != null",
                      },
                    ],
                    staticClass: "secondary",
                    attrs: {
                      title: _vm.$t("patrol.planning.btns.popup.editSeries"),
                    },
                  },
                  [_c("i", { staticClass: "fa fa-calendar" })]
                ),
                _vm._v(" "),
                _c(
                  "Btn",
                  {
                    staticClass: "secondary danger",
                    attrs: {
                      title: _vm.$t("patrol.planning.btns.popup.delete"),
                    },
                  },
                  [_c("i", { staticClass: "fa fa-trash" })]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "addMask",
          staticClass: "calendar-add-mask",
          class: { show: _vm.showMask },
          on: { mouseout: _vm.closeAddMask, click: _vm.handleAddToDate },
        },
        [_c("i", { staticClass: "fa fa-plus" })]
      ),
      _vm._v(" "),
      _c(
        "Modal",
        { ref: "modalAddEvent", attrs: { width: "400px", height: "710px" } },
        [
          _c("span", {
            attrs: { slot: "header" },
            domProps: {
              innerHTML: _vm._s(_vm.$t("patrol.planning.titles.add.event")),
            },
            slot: "header",
          }),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "content" }, slot: "content" },
            [
              _c("PlanningForm", {
                ref: "modalAddEventForm",
                attrs: { patrols: _vm.patrols, date: _vm.selectedDate },
                on: { close: _vm.handleCloseModalAddEvent },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }